'use strict';

require('../extensions/mixin.js');
const Marionette = require('backbone.marionette');
const _ = require('lodash');
const Loading = require('../mixins/loading.js');
const AsyncRenderWatch = require('../mixins/asyncRenderWatch.js');
const BlockLoading = require('../views/blockLoading.js');

const LoadingRegion = Marionette.Region.extend({
    isLoadingRegion: true,

    /*
     * Override to allow rendering and therefore loading to happen
     * before the parent view has finished rendering/loading its data
     */
    show: function (view, options) {
        const me = this;
        options = options || {};

        // NOTE we refuse to show a destroyed view, albeit silently
        if (view.isDestroyed) {
            return view;
        }

        const parentView = me._parent._parent;
        const trueParent = options.parentLoadingView || parentView._parentLoadingView;

        if (options.forceLoadingView) {
            view._trueParentLoadingView = trueParent;
        } else if (trueParent) {
            view._parentLoadingView = trueParent;
        }

        if ((!parentView.isReloading && parentView.isRendered) || !parentView.isLoadingView) {
            return Marionette.Region.prototype.show.call(me, view, options);
        }

        view._parent = me;
        view.render();

        me.listenToOnce(parentView, 'render:finished', function () {
            Marionette.Region.prototype.show.call(me, view, options);
        });

        return view;
    },

    /*
     * Override to attach and show a loading view if this view is the top
     * level loading view in a loading view stack
     */
    attachHtml: function (view) {
        const me = this;
        me.$el.contents().detach();

        /*
         * If we are attaching a normal view or this is not a top
         * level loading view no need to attach a loading view
         */
        if (!_.result(view, 'hasLoadingView')) {
            return me.el.appendChild(view.el);
        }

        view.loadingView = new view.LoadingView({
            template: view.loadingViewTemplate
        });

        me.el.appendChild(view.loadingView.render().el);
        me.el.appendChild(view.el);

        // Pick initial loading state
        if (!view.isLoadingComplete()) {
            view.loadingView.showForView(view);
            view.el.classList.add('hide');
        } else {
            view.loadingView.el.classList.add('hide');
        }
    },

    /*
     * Override so that we do not always re-render on show.
     */
    _renderView: function (view) {
        if (!view.isRendering && !view.isRendered) {
            view.render();
        }
    },

    showLoading: function (loadingViewType, options) {
        const me = this;
        const LoadingViewType = loadingViewType || BlockLoading;
        const view = new LoadingViewType(options);
        me.show(view);
    }
});

exports = module.exports;

exports.CollectionView = Marionette.CollectionView.mixin({
    mixins: {
        loading: Loading,
        asyncRenderWatch: AsyncRenderWatch
    },
    baseRender: Marionette.CollectionView.prototype.render,

    renderChildView: function (view) {
        const me = this;
        view._parent = me;
        view._parentLoadingView = me._parentLoadingView;
        return Marionette.CollectionView.prototype.renderChildView.apply(me, arguments);
    },

    destroyChildren: function () {
        const me = this;

        if (me.isDataLoaded()) {
            Marionette.CollectionView.prototype.destroyChildren.call(me);
        }
    }
});

exports.ItemView = Marionette.ItemView.mixin({
    mixins: {
        loading: Loading,
        asyncRenderWatch: AsyncRenderWatch
    },
    baseRender: Marionette.ItemView.prototype.render
});

exports.LayoutView = Marionette.LayoutView.mixin({
    mixins: {
        loading: Loading,
        asyncRenderWatch: AsyncRenderWatch
    },
    baseRender: Marionette.LayoutView.prototype.render,
    regionClass: LoadingRegion
});

exports.CompositeView = Marionette.CompositeView.mixin({
    mixins: {
        loading: Loading,
        asyncRenderWatch: AsyncRenderWatch
    },

    baseRender: Marionette.CompositeView.prototype.render,

    renderChildView: function (view) {
        const me = this;
        view._parent = me;
        view._parentLoadingView = me._parentLoadingView;
        return Marionette.CollectionView.prototype.renderChildView.apply(me, arguments);
    }
});

exports.LoadingRegion = LoadingRegion;
